import { createReducer, on } from '@ngrx/store';
import * as fromAddressActions from '../actions/address.action';

export const featureKey = 'address';

export interface State {
    regions: {
        data: Array<any>;
        isLoaded: boolean;
    };
    provinces: {
        data: Array<any>;
        isLoaded: boolean;
    };
    cities: {
        data: Array<any>;
        isLoaded: boolean;
    };
    barangays: {
        data: Array<any>;
        isLoaded: boolean;
    };
}

export const initialState: State = {
    regions: {
        data: [],
        isLoaded: false,
    },
    provinces: {
        data: [],
        isLoaded: false,
    },
    cities: {
        data: [],
        isLoaded: false,
    },
    barangays: {
        data: [],
        isLoaded: false,
    },
};

export const reducer = createReducer(
    initialState,
    on(fromAddressActions.getRegionsSuccess, (state: State, props: any) => ({
        ...state,
        regions: { data: props.data, isLoaded: true },
    })),
    on(fromAddressActions.getRegionsFailed, (state: State) => ({
        ...state,
        regions: { data: [], isLoaded: false },
    })),
    on(fromAddressActions.getProvincesSuccess, (state: State, props: any) => ({
        ...state,
        provinces: { data: props.data, isLoaded: true },
    })),
    on(fromAddressActions.getProvincesFailed, (state: State) => ({
        ...state,
        provinces: { data: [], isLoaded: false },
    })),
    on(fromAddressActions.getCitiesSuccess, (state: State, props: any) => ({
        ...state,
        cities: { data: props.data, isLoaded: true },
    })),
    on(fromAddressActions.getCitiesFailed, (state: State) => ({
        ...state,
        cities: { data: [], isLoaded: false },
    })),
    on(fromAddressActions.getBarangaysSuccess, (state: State, props: any) => ({
        ...state,
        barangays: { data: props.data, isLoaded: true },
    })),
    on(fromAddressActions.getBarangaysFailed, (state: State) => ({
        ...state,
        barangays: { data: [], isLoaded: false },
    })),
);
